

















































import {
    computed,
    defineComponent,
    toRefs,
    PropType,
} from '@vue/composition-api';
import { sportName as getSportName } from '@modules/eventGrid/nameExtractors';
import { getFlagByCategory } from '@src/federations/sportOffer/flags/flagMapping';
import {
    SdsBadge,
    SdsFlag,
    SdsIcon,
} from '@superbet-group/web.lib.ui-components';
import { getSportIconName } from '@core/utils/sportsOffer/sportIconMap';
import { VirtualTournament } from '@src/federations/sportOffer/competitions/types';
import { useHotTournamentCompetitionRedirect } from './useHotTournamentCompetitionRedirect';
import { useHotTournamentLiveEvents } from './useHotTournamentLiveEvents';
import { Analytics as AnalyticsSDK } from '@superbet-group/web.analytics.sdk';
import { ClickName } from '@superbet-group/product.analytics';

export default defineComponent({
    name: 'HotTournament',
    props: {
        tournament: {
            type: Object as PropType<VirtualTournament>,
            required: true,
        },
    },
    setup(props) {
        const { tournament: hotTournament } = toRefs(props);
        const { redirectToCompetition } = useHotTournamentCompetitionRedirect();
        const { liveEvents } = useHotTournamentLiveEvents(hotTournament);

        const onHotTournamentClick = (hotTournament: VirtualTournament) => {
            AnalyticsSDK.getInstance().log('click', {
                click_name: ClickName.HOT_TOURNAMENTS_CLICK,
                click: {
                    click_value: hotTournament.competitionId.toString(),
                    type: 'general_click',
                },
            });
            redirectToCompetition(hotTournament);
        };

        const sportIcon = computed(() => getSportIconName(props.tournament.sportId));

        return {
            sportIcon,
            liveEvents,
            getSportName,
            getFlagByCategory,
            onHotTournamentClick,
        };
    },
    components: {
        SdsFlag,
        SdsBadge,
        SdsIcon,
    },
});
